import _classCallCheck from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module indent/indentcommandbehavior/indentusingclasses
 */

/**
 * The block indentation behavior that uses classes to set indentation.
 *
 * @implements module:indent/indentblockcommand~IndentBehavior
 */
var IndentUsingClasses = /*#__PURE__*/function () {
  /**
   * Creates an instance of the indentation behavior.
   *
   * @param {Object} config
   * @param {String} config.direction The direction of indentation.
   * @param {Array.<String>} config.classes A list of classes used for indentation.
   */
  function IndentUsingClasses(config) {
    _classCallCheck(this, IndentUsingClasses);

    /**
     * The direction of indentation.
     *
     * @type {Boolean}
     */
    this.isForward = config.direction === 'forward';
    /**
     * A list of classes used for indentation.
     *
     * @type {Array.<String>}
     */

    this.classes = config.classes;
  }
  /**
   * @inheritDoc
   */


  _createClass(IndentUsingClasses, [{
    key: "checkEnabled",
    value: function checkEnabled(indentAttributeValue) {
      var currentIndex = this.classes.indexOf(indentAttributeValue);

      if (this.isForward) {
        return currentIndex < this.classes.length - 1;
      } else {
        return currentIndex >= 0;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getNextIndent",
    value: function getNextIndent(indentAttributeValue) {
      var currentIndex = this.classes.indexOf(indentAttributeValue);
      var indexStep = this.isForward ? 1 : -1;
      return this.classes[currentIndex + indexStep];
    }
  }]);

  return IndentUsingClasses;
}();

export { IndentUsingClasses as default };